import React from "react";
import CountUp from "react-countup";
import "./CounterSection.css";

const CounterSection = () => {
  const stats = [
    { label: "App Rating", value: 4.5, suffix: "★" },
    { label: "Users", value: 30, suffix: "M+" },
    { label: "Services Done", value: 3, suffix: "M+" },
    { label: "Countries", value: 30, suffix: "+" },
  ];
  return (
    <section className="m-5">
      <div className="counter-container">
        {stats.map((stat, index) => (
          <div className="counter-box" key={index}>
            <div className="counter-value">
              <CountUp
                end={stat.value}
                duration={5}
                suffix={stat.suffix}
                decimals={stat.label === "App Rating" ? 1 : 0}
              />
            </div>
            <p className="counter-label">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CounterSection;
